<div [@zoomInOnEnter] class="session" [class.usedWithinEventSelection]="usedWithinEventSelection" role="region">
	<div class="title">
		<div class="sessionTitleCon nomargin">
			<div class="sessionIcon">
				<i class="{{ session?.faIconStyle }} + ' ' + {{ session?.faIconName }}"></i>
			</div>
			<h3 class="mat-h2 sessionTitle nomargin">
				{{ session?.title }}
			</h3>
		</div>

		<div class="sessionEstimatedTimeNonSim">
			<div class="descriptiveSessionTimeIcon">
				<i class="fad fa-stopwatch"></i>
			</div>

			<div class="sessionTime">
				{{ session.startTime | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }}
				-
				{{ session.endTime | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }}
			</div>
		</div>
	</div>

	<div class="location">
		<div class="description">
			{{ T.SHARED_EVENT_SESSION_ROOMS | translate }}
		</div>
		@if (session) {
			<div class="value sessionTrainingRooms">
				@for (trainingRoomId of session?.reservedRoomIds; track trainingRoomId) {
					@let trainingRoom = trainingRoomId | getTrainingRoomById | async;
					<div class="trainingRoomLink showDotsOnOverflow">
						<a class="clickable" (click)="showDetailRoom(trainingRoom)">{{ trainingRoom?.name }}</a>
					</div>
				}
				@if (session?.reservedRoomIds?.length === 0) {
					{{ T.SHARED_EVENT_SESSION_NO_ROOM_SELECTED | translate }}
				}
			</div>
		}
	</div>

	<mat-divider />

	<div class="sessionDescriptionNonSimulation">
		<div class="description">
			@if (session?.description && session?.description?.length > 0) {
				{{ session.description }}
			}

			@if (!session?.description || session?.description?.length === 0) {
				{{ T.BOOKMARKS_EDIT_LIBRARY_NO_DESCRIPTION | translate }}
			}
		</div>
	</div>

	<mat-divider />

	<div class="actions" appStopPropagation>
		@if (showRemoveAction) {
			<button mat-icon-button color="warn" (click)="delete.emit()">
				<mat-icon fontSet="fas" fontIcon="fa-trash" inline />
			</button>
		}

		@if (showEditAction) {
			<button mat-icon-button color="accent" (click)="edit.emit()">
				<mat-icon fontSet="fas" fontIcon="fa-pencil" inline />
			</button>
		}
	</div>
</div>
